export const TRIGGERS = [
  {
    value: 'crm',
    label: 'Обоснованная жалоба в CRM'
  },
  {
    value: 'active',
    label: 'Активация upsell бонусов'
  },
  {
    value: 'welcome',
    label: 'Welcome бонус'
  },
  {
    value: 'promocode',
    label: 'Промокод'
  },
  {
    value: 'retention',
    label: 'Программа удержаний абонентов'
  }
];
